import { coursesRoutes } from "@circle-react/lib/routes/courses";

import { t } from "@/i18n-js/instance";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

const i18nRoot = "settings_nav_v3.courses";

export const useCoursesLinks = (): Link[] => [
  {
    label: t([i18nRoot, "overview"]),
    path: coursesRoutes.overview(),
    exact: true,
  },
  {
    label: t([i18nRoot, "courses"]),
    path: coursesRoutes.list(),
    exact: true,
  },
  // Part of the new dock IA but not yet defined: the Courses "Lessons" page has
  // no route yet (no coursesRoutes.lessons). Uncomment and wire up the path
  // (and add the i18n key) once the destination exists.
  // {
  //   label: t([i18nRoot, "lessons"]),
  //   path: coursesRoutes.lessons(),
  //   exact: true,
  // },
];

export const CoursesLinks = () => {
  const links = useCoursesLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t([i18nRoot, "title"])}>
        {links.map(link => (
          <SubNavLinkItem key={link.path} to={link.path} {...link} />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
